module.exports = __webpack_public_path__ + "img/thumbnail_Wolverine_m_leucistic.e58d2d6d.png";